import React from 'react';
import '../App.css';
import Dashboard from './Dashboard';


const Skills = () => {
  return (
    <div className='skills'>
        <Dashboard></Dashboard>
    </div>
  );
};

export default Skills;
